import { render } from "./FireDetailsView.vue?vue&type=template&id=7b5252e8&scoped=true"
import script from "./FireDetailsView.vue?vue&type=script&lang=js"
export * from "./FireDetailsView.vue?vue&type=script&lang=js"

import "./FireDetailsView.vue?vue&type=style&index=0&id=7b5252e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5252e8"]])

export default __exports__